export default defineNuxtRouteMiddleware(async (to, from) => {
    const config = useRuntimeConfig();
    if (to.meta.skipMiddleware) {
        return;
    }

    const userState = useState<any>('auth-user', () => null);

    if (userState.value && from?.params?.org_slug === to.params.org_slug) {
        to.meta.user = userState.value;
        return;
    }

    const cookieHeaders = import.meta.server ? useRequestHeaders(['cookie']) : {};

    const { data: user, error } = await useFetch(`/api/${to.params.org_slug}/auth`, {
        headers: {
            ...cookieHeaders,
            Accept: 'application/json',
            'X-Api-Request': 'true',
            'X-Product': config.public.isSurveys ? 'surveys' : 'forms',
        },
    });

    if (error.value) {
        console.error('Auth middleware fetch failed:', error.value);
        if (userState.value) {
            to.meta.user = userState.value;
            return;
        }
    }

    if (!user.value) {
        if (process.env.NODE_ENV === 'development') {
            console.log('Development environment detected - skipping login redirect');
            return;
        }
        const loginUrl = `${config.public.boardDomain}/login?redirect=${config.public.isSurveys ? 'surveys' : 'forms'}&org=${to.params.org_slug}`;
        return navigateTo(loginUrl, { external: true });
    }

    if (user.value?.role === "observer") {
        return navigateTo(`/${to.params.org_slug}/form/observer`, { external: true });
    }

    if (config.public.isForms && user.value?.role !== "admin") {
        return navigateTo(`${config.public.boardDomain}/login`, { external: true });
    }

    userState.value = user.value;
    to.meta.user = user.value;
});
